<template>
  <div class="card">
    <div class="card-header">
      <div class="badge-title purple">Площадки</div>
      <date-picker v-model="date"
                   locale="ru"
                   :clearable="false"
                   format="dd.MM.yyyy"
                   model-type="yyyy-MM-dd"
                   auto-apply
                   :enable-time-picker="false"></date-picker>
    </div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table table-hover table-borderless">
          <thead>
          <tr>
            <td>Всего <i class="bi bi-info"></i></td>
            <td>Отзывы <i class="bi bi-info"></i></td>
            <td>Рейтинг <i class="bi bi-info"></i></td>
          </tr>
          <tr>
            <th>
              <span v-if="resources.length">{{ resources.length }} </span>
              <span v-else class="nd">н/д</span>
            </th>
            <th>
              <span v-if="total.review">{{ total.review }}
                <span v-if="total.review_diff"
                      :class="'diff ' +(total.review_diff>0?'text-success':'text-danger')">
                  <i :class="'bi bi-arrow-'+(total.review_diff>0?'up':'down')"></i>{{ formatNumber(total.review_diff) }}</span>
              </span>
              <span class="nd" v-else>н/д</span>
            </th>
            <th>
              <span v-if="total.rating">{{ total.rating }}
                <span v-if="total.rating_diff"
                      :class="'diff ' + (total.rating_diff>0?'text-success':'text-danger')">
                  <i :class="'bi bi-arrow-'+(total.rating_diff>0?'up':'down')"></i>{{ total.rating_diff }}%
                </span>
              </span>
              <span v-else class="nd">н/д</span>
            </th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(resource, index) in resources">
            <tr v-if="(!showed && index < 8) || showed">
              <td>
                <div class="resource">
                  <span class="img" v-if="resource.resource?.ico"
                        :style="{backgroundImage: `url(${resource.resource.ico})`}"></span>
                  <span class="img no-image" v-else :style="{backgroundColor: resource.resource?.color}"></span>

                  <span class="name">{{ resource.resource?.name || resource.resource?.domain }}</span></div>
              </td>
              <td><span v-if="resource.review_count">{{ resource.review_count }}</span>
                <div v-else class="badge bg-secondary">н/д</div>
              </td>
              <td>
                <span v-if="resource.rating">{{ resource.rating }}</span>
                <span v-else class="badge bg-secondary">н/д</span>
              </td>
            </tr>
          </template>
          </tbody>

        </table>
      </div>
    </div>
    <div class="card-footer">
      <button class="btn btn-sm btn-show-all" v-if="resources.length >8" @click="showed=!showed">
        <template v-if="showed">Скрыть</template>
        <template v-else>Посмотреть все</template>
      </button>
    </div>
  </div>


</template>

<script>


import {ReviewApi} from "@/api/reviews";
import moment from "moment";

export default {
  name: 'ResourceStat',
  props: {},
  data() {
    return {
      date: moment().format("YYYY-MM-DD"),
      showed: false,
      resources: []
    }
  },
  watch: {
    date() {
      this.getData();
    }
  },
  mounted: function () {
    this.getData();


  },
  computed: {
    total() {
      let total = {review: 0, rating: 0, rating_diff: 0, review_diff: 0}
      total.review = this.resources.map(x => x.review_count || 0).reduce((a, b) => a + b, 0)
      const rating_sum = this.resources.map(x => x.rating || 0).reduce((a, b) => a + b, 0)
      total.rating = rating_sum ? (rating_sum / this.resources.length).toFixed(2) : 0
      total.rating_diff = (((this.resources.map(x => x.rating_prev || 0).reduce((a, b) => a + b, 0) / this.resources.length)) - total.rating).toFixed(2)
      total.review_diff = total.review - this.resources.map(x => x.total_reviews_prev || 0).reduce((a, b) => a + b, 0)
      return total
    }
  },

  methods: {
    getData() {
      ReviewApi.resource_stat(this.date).then(response => this.resources = response)
    },
    formatNumber(num) {
      if (Math.abs(num) >= 1000) {
        console.log(num)
        return (num / 1000).toFixed(1) + 'K';
      }
      return num.toString();
    }
  }
}

</script>
<style scoped lang="scss">
.card {
  .btn-show-all {
    height: 28px;
    background: rgba(138, 142, 155, 0.1);
    border: 1px solid rgba(196, 199, 207, 1);
    font-size: 14px;
    font-weight: 500;
    color: rgba(108, 110, 121, 1);
    display: flex;
    align-items: center;
  }

  .card-body {
    .table-responsive {
      table {
        width: 100%;

        thead {
          td {
            font-size: 14px;
            font-weight: 400;
          }

          th {
            padding: 10px 0;
            color: rgb(0, 143, 248);
            font-size: 24px;
            font-weight: 700;
            line-height: 24px;

            .nd {

              color: rgba(169, 171, 182, 1);
            }

            .diff {
              font-size: 12px;
              font-weight: normal;
            }
          }
        }

        tbody {
          .resource {
            display: flex;
            gap: 4px;
            align-items: center;
            margin-bottom: 10px;

            .img {
              display: inline-block;
              width: 16px;
              height: 16px;
              background-position: center;
              background-size: contain;

              &.no-image {
                background: #ccc;
                border-radius: 16px;
              }
            }

            .name {
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
            }
          }

          .bg-secondary {
            font-size: 10px;
            font-weight: 500;
            padding: 2px 4px;
            line-height: 10px;
            background: rgba(138, 142, 155, 1);
          }
        }
      }
    }


  }
}
</style>

